<template>
  <div class="ftRow ftHeader">
    <p
      class="ftCell"
      :style="{ width: cellWidth(data) }"
      v-for="(col, index) in data"
      :key="index"
    >
      <span v-if="col === 'Actions'" class="textRight"> </span>
      <span v-else>
        {{ col }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  methods: {
    cellWidth(data) {
      return 100 / data.length + "%";
    },
  },
};
</script>
